const faqItems = [
  {
    q: '51影视真的完全免费吗？',
    a: '是的，51影视承诺所有影视内容完全免费观看。无需注册账号、无需购买会员、无需任何付费。我们通过广告收入维持平台运营，让每一位观众都能享受免费影视在线观看服务。',
  },
  {
    q: '为什么播放时不缓冲、不卡顿？',
    a: '51影视采用智能CDN加速和自适应码率技术，在全国部署了100+加速节点。系统会根据您的网络状况自动调整画质，即使网速一般也能流畅播放。同时我们持续优化服务器性能，确保高清不卡顿的观影体验。',
  },
  {
    q: '可以在手机上观看吗？需要下载APP吗？',
    a: '当然可以！51影视全面支持手机、平板等移动设备，无需下载任何APP。只需打开手机浏览器访问51影视，即可享受与电脑端一致的高清流畅体验。界面针对移动端深度优化，操作简单便捷。',
  },
  {
    q: '片库多久更新一次？新剧什么时候上线？',
    a: '我们的片库每日更新，热门剧集通常会在播出后24小时内上线。院线新片也会以最快速度与大家见面。您可以通过首页的"最新动态"模块实时了解片库更新情况，不错过任何一部好剧。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              你想知道的都在这里
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqItems.map((item) => (
              <div
                key={item.q}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <div className="p-5 md:p-6">
                  <h3 className="text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                    <span className="text-primary-500 flex-shrink-0 mt-0.5">
                      <i className="ri-question-line"></i>
                    </span>
                    {item.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}